import InuxeCommonButton, {
  type CommonButtonProps,
  type CommonButtonType,
} from '@inuxe/common-button';

export type { CommonButtonProps, CommonButtonType };
export { InuxeCommonButton as CommonButton };
export default InuxeCommonButton;
